module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/K2CTR5/tc-custom/1.png?1692133193045?1719603365883",
      "alt": "This image is the cover for the book The Pillow Family"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Pillow Family\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Pillow Family, which includes Mom, Dad, Puffy and Patty Pillow, are stuck in the furniture store. Mom and Dad Pillow have a dream of finding a home for their Pillow Family, which is not easy. Many customers come through the store daily and there are a lot of pillows to choose from. The Pillow Family continues to wait and have not been chosen. They hope to find a family someday that needs them as much as they need them.")]), _c('p', [_vm._v("Is it sad when a pillow cannot get a good night’s sleep because that is what they are made for – sleeping, right? Mom and Dad Pillow know that eventually they will be taken to the “Warehouse for Old Displays” if they have not been sold. Unfortunately, they are not aware how close that time really is. Will the Pillow Family find a home in time? Read the book to find out! Enjoy the adventure!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      N.C. Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "8.0pt",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("N.C. Moore resides in St. Louis, Missouri, and has had a lifelong career in the nursing profession. She enjoys living close to her family and spending time with her children and grandchildren. Reading to her children and grandchildren inspired the book "), _c('em', [_vm._v("The Pillow Family")]), _vm._v(", which N.C. Moore is excited to share with children everywhere.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0